<header>
  <h3>Notificações</h3>
</header>
<app-list [dense]="true" [dividers]="true" class="list">
  <app-list-item
    *ngFor="let notification of notificationService.notifications$ | async"
    class="notification__item"
    (clicked)="openNotificationDetails(notification)"
  >
    <app-notification-item
      [notification]="notification"
    ></app-notification-item>
  </app-list-item>
</app-list>
